module.exports = __webpack_public_path__ + "img/logo2.139b1cfc.svg";